// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3rLZI","title":"styles_title__4Nx-5","subtitle":"styles_subtitle__wVYY3","form":"styles_form__MlXBr","input":"styles_input__jPnME"};